import React from 'react'
import { ThemeProvider, createGlobalStyle } from 'styled-components'
import { theme } from './theme'

const GlobalStyle = createGlobalStyle`
  *, *::before, *::after { box-sizing: border-box; }
  html, body, #root { height: 100%; }
  body { margin: 0; font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, Helvetica Neue, Arial, "Apple Color Emoji", "Segoe UI Emoji"; color: ${theme.colors.text}; background: #fafafa; }
`

export function SoolProvider({ children, customTheme }) {
  const merged = customTheme ? { ...theme, ...customTheme } : theme
  return (
    <ThemeProvider theme={merged}>
      <GlobalStyle />
      {children}
    </ThemeProvider>
  )
}
